import React from "react";
import { Link } from "react-router-dom";
import AuthCommunity from "./AuthCommunity";
import AuthBenefits from "./AuthBenefits";

const AuthBranding = () => {
  return (
    <div className="text-white space-y-6 md:space-y-10">
      {/* Logo cliquable */}
      <Link to="/" className="flex items-center gap-4 sm:gap-5 group">
        <div className="p-2 sm:p-3 rounded-2xl bg-white shadow-2xl shadow-primary/30 transition-transform duration-300 group-hover:scale-105">
          <img
            src="/assets/logo/favicon-removebg.png"
            alt="Hubvex"
            className="h-10 sm:h-14"
          />
        </div>
        <div>
          <h2 className="text-2xl sm:text-4xl font-black tracking-tight">
            Hubvex
          </h2>
          <p className="uppercase tracking-[0.35em] text-white text-sm sm:text-lg font-bold">
            AUTH
          </p>
        </div>
      </Link>

      {/* Hero */}
      <div className="w-full space-y-4 sm:space-y-6">
        <h1 className="text-4xl sm:text-5xl 2xl:text-6xl font-black text-white tracking-tight leading-[0.92]">
          Bienvenue chez <span className="sm:hidden"><br /></span>Hubvex
        </h1>
        <p className="hidden sm:flex text-xl sm:text-xl md:text-2xl font-light text-white">
          Connectez-vous au changement.
        </p>
      </div>

      {/* Ligne décorative */}
      <div className="relative h-[6px] w-48 sm:w-72 rounded-full overflow-hidden bg-white/10">
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-white/50 via-secondary/30 to-primary/20 bg-[length:250%_100%] animate-gradient-x" />
      </div>

      {/* Communauté – toujours visible */}
      <AuthCommunity />

      {/* Bénéfices – masqués sur mobile (taille < md) */}
      <div className="hidden md:block">
        <AuthBenefits />
      </div>
    </div>
  );
};

export default AuthBranding;